import { useEffect, useState } from "react";
import { useHistory, Link } from "react-router-dom";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import GoogleSignInButton from "../common/buttons/GoogleSignInButton";
import DividerWithText from "../common/divider/DividerWithText";
import {
  signInWithEmailAndPassword,
  signInWithGoogle,
} from "../../store/actions/authActions";
import logo from "../../logo.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  box: {
    margin: "10px auto",
    padding: "0px 50px 20px 50px",
    display: "flex",
    justifycontent: "center",
    flexDirection: "column",
    maxWidth: "650px",
    minWidth: "200px",
  },
  paper: {
    padding: "20px",
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginBottom: "20px",
    justifyContent: "center",
  },
  logoImg: {
    height: "50px",
    width: "250px",
  },
  textField: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginBottom: "10px",
    justifyContent: "center",
  },
  button: {
    textTransform: "none",
    marginBottom: "10px",
    height: "50px",
  },
}));

function Login() {
  const classes = useStyles();
  const history = useHistory();
  const auth = useSelector((state) => state.firebase.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  function handlePasswordFieldChange(e) {
    setPassword(e.target.value);
  }

  function handleEmailFieldChange(e) {
    setEmail(e.target.value);
  }

  useEffect(() => {
    if (auth.uid) {
      history.replace("/dashboard");
    }
  }, [auth.uid, history]);

  return (
    <div className={classes.root}>
      <Box className={classes.box}>
        <Paper variant="outlined" className={classes.paper} elevation={5}>
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="stretch"
          >
            <Grid className={classes.gridItem} item>
              <img src={logo} className={classes.logoImg} />
            </Grid>
            <Grid className={classes.gridItem} item>
              <Typography variant="h4" component="h4">
                Team Login
              </Typography>
              <Typography variant="h6" component="h6">
                Login with your authorized account
              </Typography>
            </Grid>
            <Grid className={classes.gridItem} item xs={12}>
              <GoogleSignInButton
                onClick={() => dispatch(signInWithGoogle())}
              />
            </Grid>
            <Grid item xs={12}>
              <DividerWithText>
                Have a password? Continue with your email
              </DividerWithText>
            </Grid>
            <Grid className={classes.textField} item xs={12}>
              <TextField
                fullWidth
                label="Email"
                placeholder="Email"
                variant="outlined"
                onChange={handleEmailFieldChange}
              />
            </Grid>
            <Grid className={classes.textField} item xs={12}>
              <TextField
                fullWidth
                label="Password"
                type="password"
                placeholder="Password"
                variant="outlined"
                onChange={handlePasswordFieldChange}
              />
            </Grid>
            <Grid className={classes.gridItem} item xs={12}>
              <Button
                fullWidth
                color="primary"
                className={classes.button}
                disabled={false}
                disableElevation={true}
                variant="contained"
                onClick={() =>
                  dispatch(
                    signInWithEmailAndPassword({
                      email: email,
                      password: password,
                    })
                  )
                }
              >
                Continue
              </Button>
            </Grid>
            <Grid item xs={12}>
              <DividerWithText>
                Don't have an account? Sign Up <Link to="/signup">here</Link>
              </DividerWithText>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </div>
  );
}

export default Login;
